import React from "react"
import {Route, Switch} from "react-router-dom"
import {UnitView} from "./UnitView"
import {UnitListView} from "./UnitListView"
import * as Util from "../common"
import withProps from "recompose/withProps"

export function UnitsRouter(props) {
  const {match, readonly} = props
  return (
    <Switch>
      <Route
        exact
        path={match.path + "/:unitName"}
        render={withProps({readonly})(UnitView)}
      />
      <Route
        exact
        path={match.path}
        render={withProps({readonly})(UnitListView)}
      />
      <Route render={Util.NotFoundView} />
    </Switch>
  )
}



// WEBPACK FOOTER //
// ./src/units/UnitsRouter.js